import { useRef, useState } from 'react';
import { Paperclip, Loader2 } from 'lucide-react';
import { uploadChunked } from '../../utils/chatUpload';

// Paperclip button + progress for chunked chat uploads (used by visitor widget and admin thread)
export const AttachButton = ({ url, extra = {}, onUploaded, onError, className = '', testId }) => {
  const ref = useRef(null);
  const [pct, setPct] = useState(null);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setPct(0);
    try { onUploaded(await uploadChunked(url, file, extra, setPct)); } catch (err) { onError(err.message); } finally { setPct(null); }
  };

  return (
    <>
      <input ref={ref} type="file" className="hidden" onChange={pick} data-testid={`${testId}-input`} />
      <button type="button" disabled={pct !== null} onClick={() => ref.current?.click()} title="Attach a file (up to 100 MB)" aria-label="Attach file"
        className={`relative shrink-0 flex items-center justify-center transition-colors disabled:cursor-wait ${className}`} data-testid={testId}>
        {pct === null ? <Paperclip size={17} /> : <><Loader2 size={16} className="animate-spin" /><span className="absolute -top-2 -right-2 text-[9px] font-bold bg-green-600 text-white rounded-full px-1" data-testid={`${testId}-progress`}>{pct}%</span></>}
      </button>
    </>
  );
};
